import { useState, useEffect } from 'react';
import { getUser } from '../services/api';
import type { User } from '../types';

export function useCurrentUser() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getUser()
      .then(setUser)
      .catch((err: Error & { status?: number }) => {
        if (err.status !== 401) setError(err.message);
        // 401 = not signed in — leave user as null, no error
      })
      .finally(() => setLoading(false));
  }, []);

  return { user, loading, error };
}
